import { QRFC } from "./QRFC";

export class QResetGuideStateRFC extends QRFC {
  constructor() {
    super();
  }

  Init(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
    this.SetAsync(true);
  }

  GetCallName() {
    return "guides/reset";
  }

  SetParams(orgName, user, guideIds) {
    this.AddParameter("org", orgName);
    this.AddParameter("user", user);
    this.AddParameter("guideIds", JSON.stringify(guideIds));
  }

  DoTransactionComplete(response, callBackObj) {
    const r = this.SafeParseResponse(response);
    if (!r) return;
    callBackObj?.HandleGuideStateReset?.(r);
  }
}
